import { render, staticRenderFns } from "./lang-dropdown.vue?vue&type=template&id=0c821f56&lang=pug&"
import script from "./lang-dropdown.vue?vue&type=script&lang=js&"
export * from "./lang-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports